var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunicationreveiw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M27.9998 15.0547C27.9998 21.1067 22.6025 25.964 15.9998 25.964C15.1451 25.964 14.3131 25.88 13.5078 25.7254",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M8.79867 23.768C5.89333 21.7814 4 18.632 4 15.0547",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M8.799 23.7681C8.79767 24.9067 8.80033 26.4427 8.80033 28.0547",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M4 15.0547C4 9.00273 9.39733 4.14673 16 4.14673C22.6027 4.14673 28 9.00406 28 15.0561",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M13.5065 25.72L8.7998 28.0533",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M16.2354 15.0977C16.3656 15.2279 16.3656 15.4389 16.2354 15.5691C16.1052 15.6993 15.8941 15.6993 15.764 15.5691C15.6338 15.4389 15.6338 15.2279 15.764 15.0977C15.8941 14.9675 16.1052 14.9675 16.2354 15.0977",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M21.5694 15.0977C21.6995 15.2279 21.6995 15.4389 21.5694 15.5691C21.4392 15.6993 21.2281 15.6993 21.098 15.5691C20.9678 15.4389 20.9678 15.2279 21.098 15.0977C21.2281 14.9675 21.4392 14.9675 21.5694 15.0977",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M10.9024 15.0977C11.0325 15.2279 11.0325 15.4389 10.9024 15.5691C10.7722 15.6993 10.5611 15.6993 10.431 15.5691C10.3008 15.4389 10.3008 15.2279 10.431 15.0977C10.5611 14.9675 10.7722 14.9675 10.9024 15.0977",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationreveiw);
export default __webpack_public_path__ + "static/media/communicationreveiw.b1bc50a3f01a57e2321df58425292d2e.svg";
export { ForwardRef as ReactComponent };